var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.contestData.name != null)?_c('div',[(_vm.contestData.isVote)?_c('vote'):_c('div',[(_vm.enter)?_c('enter',{attrs:{"contest-id":_vm.contestData.id},on:{"edit":function($event){return _vm.editEntry()}}}):_c('edit')],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }